import { Injectable } from '@angular/core';
import { Router, UrlMatchResult, UrlSegment } from '@angular/router';

import { ApWindowService } from '@ap/cdk';

import { ErrorData } from './betaalverzoek.model';

/**
 * @module BetaalverzoekModule
 * @ngdoc service
 * @name BetaalverzoekNavigation
 */
@Injectable({
    providedIn: 'root'
})
export class BetaalverzoekNavigation {
    public static readonly errorPagePath = 'fout';
    public static readonly transactionSuccessReturnPath = 'betaling';
    public static readonly landingPageV2Path = 'v2/:id/:ac';
    public static readonly successReturnV2Path = 'v2/betaling';

    public constructor(
        private readonly router: Router,
        private readonly windowService: ApWindowService
    ) {}

    public static containsIdAndSecureParam(url: UrlSegment[]): UrlMatchResult {
        const charactersAfterTheDash32 = /-[a-zA-Z0-9]{32}$/;
        // eslint-disable-next-line
        return url.length === 1 && url[0].path.match(charactersAfterTheDash32) ? { consumed: url, posParams: { 'id-ac': url[0] } } : null;
    }

    public external(href: string): void {
        this.windowService.location_href(href);
    }

    public toErrorPage(errorData: ErrorData): void {
        this.navigateInternalWithErrorData(BetaalverzoekNavigation.errorPagePath, errorData);
    }

    private navigateInternalWithErrorData(path: string, errorData: ErrorData): void {
        this.router.navigate([`./${path}`], { state: { data: errorData } });
    }
}
